import { render, staticRenderFns } from "./focusReply.vue?vue&type=template&id=4d9a7f5b&scoped=true&"
import script from "./focusReply.vue?vue&type=script&lang=ts&"
export * from "./focusReply.vue?vue&type=script&lang=ts&"
import style0 from "./focusReply.vue?vue&type=style&index=0&id=4d9a7f5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9a7f5b",
  null
  
)

export default component.exports